import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPackage, IPackageInitialState } from "./packageModel";
import {
  ActiveInactivePackage,
  PackageImageUpload,
  createPackage,
  deletePackage,
  getAllActivePackages,
  getAllPackages,
  getPackageByID,
  updatePackage,
} from "./services/package.services";

const initialState: IPackageInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PackageID: null,
  PackageList: [],
  PackageDetail: {
    ID: null,
    PackageTitle: "",
    PackageURL: "",
    PropertyID: null,
    City: "",
    ValidityPeriod: "",
    PackageInclusion: "",
    ChildPolicy: "",
    CancellationPolicy: "",
    CheckinCheckoutInfo: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    IsFree: false,
    FreeTitle: "",
    Roompricingdetails: [],
    IsActive: 1,
  },
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    clearPackageDetails: (state) => {
      state.PackageDetail = initialState.PackageDetail;
    },
    setPackageID: (state, action) => {
      state.PackageID = action.payload;
    },
    clearPackageID: (state) => {
      state.PackageID = initialState.PackageID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPackages.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPackages.fulfilled,
      (state, action: PayloadAction<IPackage[]>) => {
        state.loading = false;
        state.PackageList = action.payload || [];
      },
    );
    builder.addCase(getAllPackages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PackageList = [];
    });
    builder.addCase(createPackage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createPackage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createPackage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updatePackage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updatePackage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePackage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deletePackage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePackage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePackage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPackageByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPackageByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PackageDetail = action.payload;
    });
    builder.addCase(getPackageByID.rejected, (state, action) => {
      state.loading = false;
      state.PackageDetail = initialState.PackageDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActivePackages.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePackages.fulfilled,
      (state, action: PayloadAction<IPackage[]>) => {
        state.loading = false;
        state.PackageList = action.payload || [];
      },
    );
    builder.addCase(getAllActivePackages.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PackageList = [];
    });
    builder.addCase(ActiveInactivePackage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactivePackage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactivePackage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(PackageImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(PackageImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(PackageImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearPackageDetails, clearPackageID, setPackageID } =
  packageSlice.actions;
export default packageSlice.reducer;
